import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import IconButton from "./IconButton";

/**
 * A reusable fixed header component for pages
 * @param {string} title - Page title to display
 * @param {function} onBack - Back button click handler
 * @param {string} className - Additional CSS classes
 */
export default function PageHeader({ title, onBack, className = "" }) {
  return (
    <div className={`header fixed-top bg-info ${className}`}>
      <div className="page-title-section d-flex flex-row align-items-center">
        {onBack && (
          <IconButton
            icon={faChevronLeft}
            variant="secondary"
            onClick={onBack}
            className="my-auto rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px" }}
          />
        )}
        <h2 className="page-title ms-3 my-auto text-white fw-semibold">
          {title}
        </h2>
      </div>
    </div>
  );
}
